// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-icon-btn,
a.action-icon-btn,
a.action-icon-btn:visited,
a.action-icon-btn:link {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  font-size: 17px;
  color: var(--azul) !important;
  opacity: 0.8;
  transition: opacity 0.15s;
  text-decoration: none;
}

.action-icon-btn:hover,
a.action-icon-btn:hover {
  opacity: 1;
}

.action-icon-tooltip {
  position: fixed;
  transform: translateX(-100%) translateY(-100%);
  background-color: #333;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
  pointer-events: none;
  z-index: 99999;
  overflow: visible;
}

`, "",{"version":3,"sources":["webpack://./src/components/ActionIconButton/actionIconButton.css"],"names":[],"mappings":"AAAA;;;;EAIE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".action-icon-btn,\na.action-icon-btn,\na.action-icon-btn:visited,\na.action-icon-btn:link {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  border-radius: 6px;\n  font-size: 17px;\n  color: var(--azul) !important;\n  opacity: 0.8;\n  transition: opacity 0.15s;\n  text-decoration: none;\n}\n\n.action-icon-btn:hover,\na.action-icon-btn:hover {\n  opacity: 1;\n}\n\n.action-icon-tooltip {\n  position: fixed;\n  transform: translateX(-100%) translateY(-100%);\n  background-color: #333;\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.3;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);\n  pointer-events: none;\n  z-index: 99999;\n  overflow: visible;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
